import { useTranslations } from "../../hooks/useTranslations";
import { SP } from "../../http/serviceportalApi";
import { getDefaultPeriod, getWageCostPeriodUntil } from "../../utils";

interface Props {
  id?: string;
  period: SP.Period;
  onPeriodChange: (period: SP.Period) => void;
}

const maxFromYear = getDefaultPeriod(getWageCostPeriodUntil()).from.year;

const NumberOfYearsSelect = ({ id, period, onPeriodChange }: Props) => {
  const { i18n } = useTranslations();
  return (
    <select
      id={id}
      value={period.from.year}
      onChange={(e) =>
        onPeriodChange({
          ...period,
          from: { ...period.from, year: +e.target.value },
        })
      }
    >
      <option value={maxFromYear}>
        1 {i18n.bilanzOnline.wageCostCharts.yearsSelect.year}
      </option>
      <option value={maxFromYear - 1}>
        2 {i18n.bilanzOnline.wageCostCharts.yearsSelect.years}
      </option>
      <option value={maxFromYear - 2}>
        3 {i18n.bilanzOnline.wageCostCharts.yearsSelect.years}
      </option>
    </select>
  );
};

export default NumberOfYearsSelect;
